import { AnaColumn, costantValue } from "../forms-template.service";

export const lotto: AnaColumn[] = [
    {
      configuration:
      {
        titleGriglia: 'descrizioneSoggetto - $descrizioneSede',
        titleForm: 'descrizioneSoggetto - $descrizioneSede',
        // breadcrumbCaption: 'Lotti di Produzione',
        campoTitle: ['descrizioneSede','descrizioneSoggetto'],
        service: 'lotto',
        api: 'lotto',
        filterList: '/$idSede',
        filterEditor: '?id=$',
        helpDoc: 'Lotti.html',
        queryFilter:[
          
        ],
        idTabRif: [
         
          {
            key: 'idSede',
            value: 'idSede'
          },
         
  
        ],
        formType: 'simple',
        masterKey: 'id',
        nCol: 1,
        toolbarSettings: {
          service: 'lotto',
         
        }
  
  
  
      
  
      }
  
    },
    
    {
      itemType: "group", groupWidth:560,  groupDataField:'datiLotto', colCount: "2", caption: 'Dati Lotto di Produzione', colSpan: "2", data: [
      
        { 
          orderGriglia:1,
          showInColumnChooser:true,
          allowHiding:false,
          type: 'campo', 
          dataField: "numero", 
          caption: "Num.Lotto",  
          maxSize: 35, 
          maxLength: "12",
          colSpan:2,
          nCol:4,
          validation: [{
           type: 'required', message: 'Campo Num.Lotto obbligatorio'
          }]
        },
        
        
        {
          orderGriglia:2,
          type: 'campo', 
          dataField: "descrizione", 
          caption: "Descrizione", 
          maxSize: 45, 
          maxLength: "50",
          showInColumnChooser:true,
          allowHiding:false,
          editorClass:'text-capitalize',
          colSpan:2,
          nCol:8
        },

        
        { 
          colVisible:true ,
          orderGriglia:3,
          type: 'campoData', 
          dataField: "dataInizio", 
          format: "dd/MM/yyyy", 
          editorType: "dxDateBox", 
          dataType: "date", 
          caption: "Data Inizio", 
          nCol:4,
          validation: [{
                type: 'required', message: 'Campo Data Inizio obbligatorio'
          }]
        },
        
        {
          colVisible:true, 
          orderGriglia:4,
          nCol:4,
          labelWidth:90,
          type: 'campoData', 
          dataField: "dataFine", 
          format: "dd/MM/yyyy", 
          editorType: "dxDateBox", 
          dataType: "date", 
          caption: "Data Fine",
        },

      ]
    },
  ]